import React, { useCallback, useContext, useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { storeDetailsAction } from "../../../redux/actions/invoices-action";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import moment from "moment";
import { DataContext } from "../../../components/layouts/main-layout";
import {

  ArrowDown,
  ArrowRightLeft,
  ArrowUp,
  TimerIcon,
} from "lucide-react";
import {
  stockTransferTableAction,
  stockTransferViewAction,
  voidStockTransferAction,

} from "../../../redux/actions/inventory-action";
import StockManagementFilter from "../../../components/tables/table-filter/stock-transfer-filter";
import { formatString } from "../../../components/helper-components/helper-function";
import DynamicTransactionTable from "../../../components/tables/dynamic-transaction-table";
import BadgesComponent from "../../../components/tables/badges-component";
import PillBadge from "../../../components/helper-components/pill-badge";
import TransSummaryComp from "../../../components/helper-components/trans-summary-comp";

const StockTransferTable = () => {
  const [heading, setHeading] = useState([]);
  const [billSummary, setBillSummary] = useState({});

  const [showFilter, setShowFilter] = useState(false);
  const { permissionFn } = useContext(DataContext);
  const dispatch = useDispatch();
  const [expandedRows, setExpandedRows] = useState([]);
  const [reload, setReload] = useState(false);
  const [orders, setOrders] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [action, setAction] = useState(false);
  const [subAction, setSubAction] = useState(false);
  const [itemLoading, setItemLoading] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [currentSubIndex, setCurrentSubIndex] = useState(null);
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [storeDetails, setStoreDetails] = useState({});

  useEffect(() => {
    dispatch(storeDetailsAction(onSuccessStoreDetails, onErrorStoreDetails));

    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const transferData = parsed.find((obj) => obj?.stock_transfer_list);
      if (transferData?.stock_transfer_list) {
        setHeading(
          transferData.stock_transfer_list.filter(
            (col) => col?.value !== "updated_user_name"
          )
        );
      }
    }
  }, []);
  const onSuccessStoreDetails = (data) => {
    setStoreDetails(data?.data);
  };
  const onErrorStoreDetails = () => {};
  const [filterData, setFilterData] = useState({
    sort_by: "",
    sort_order: "",
    selectColumn: "stock_transfer_doc_number",
    from: "",
    to: "",
    inputValue: "",
    filterValue: "",
  });
  useEffect(() => {
    dispatch(
      stockTransferTableAction(
        {
          pageNumber: currentPage,
          pageSize: pageSize,
          filterData,
        },
        onSuccess,
        onError
      )
    );
  }, [currentPage, pageSize, filterData, reload]);
  const onSuccess = (data) => {
    setError(false);
    setLoading(false);
    setOrders(data?.data?.orderList);
    setDataCount(data?.data?.totalCount);
    setBillSummary(data?.data?.getorderStats);
  };
  const onError = (data) => {
    setError(true);
    setLoading(false);
  };
  const navigate = useNavigate();
  const paginationProps = {
    pageSize: pageSize,
    setPageSize: setPageSize,
    dataCount: dataCount,
    setCurrentPage: setCurrentPage,
    currentPage: currentPage,
  };

  const initialFilter = {
    sort_by: "",
    sort_order: "",
    selectColumn: "stock_transfer_doc_number",
    from: "",
    to: "",
    inputValue: "",
    filterValue: "",
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        action &&
        currentIndex != null &&
        !event.target.closest(".relative")
      ) {
        setAction(false);
        setCurrentIndex(null);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [action, currentIndex]);

  const tableBodyData = orders?.map((item) => {
    return {
      id: item?.itt_id,
      stock_transfer_doc_number:
        (
          <span className="cursor-pointer text-secondary fw_500">
            {item?.stock_transfer_doc_number ?? "--"}
          </span>
        ) ?? "--",

      posting_date: item?.posting_date
        ? moment(item?.posting_date).format("DD-MM-YYYY")
        : null,
      stock_management_action: (
        <PillBadge
          text={formatString(item?.stock_management_action)}
          className={`${
            item?.stock_management_action === "stock_out"
              ? "bg-[var(--pill-badge-red-bg)]"
              : item?.stock_management_action === "stock_in"
              ? "bg-[var(--pill-badge-green-bg)]"
              : item?.stock_management_action === "in_store_transfer"
              ? "bg-[var(--pill-badge-yellow-bg)]"
              : item?.stock_management_action === "stock_transfer_request"
              ? "bg-[var(--pill-badge-blue-bg)]"
              : ""
          }`}
        />
      ),
      from_warehouse_name: item?.from_warehouse_name ?? "--",
      to_warehouse_name: item?.to_warehouse_name ?? "--",
      stock_transfer_status: (
        <BadgesComponent status={item?.stock_transfer_status} />
      ),
      is_stock_in_void_able:
        item?.stock_transfer_status === "success"
          ? item?.is_stock_in_void_able
            ? "No"
            : "Yes"
          : "--",
      //  item?.is_stock_in_void_able ?? false,
      itemData: item?.itemData?.length > 0 ? item?.itemData : [],
      itt_order_status: !item?.is_stock_in_void_able
        ? "yes"
        : item?.stock_transfer_status,
      data_synced:
        item?.stock_management_action === "stock_transfer_request"
          ? true
          : false,
      created_date: item?.created_date
        ? moment(item?.created_date).format("DD MMM YYYY")
        : "--",
      update_date: item?.update_date
        ? moment(item?.update_date).format("DD MMM YYYY")
        : "--",
      created_user_name: item?.created_user_name ?? "--",
      updated_user_name: item?.updated_user_name ?? "--",
    };
  });

  const filterby = showFilter ? (
    <StockManagementFilter
      filterData={filterData}
      setFilterData={setFilterData}
      setCurrentPage={setCurrentPage}
    />
  ) : null;
  const handleFilterClick = useCallback(() => {
    setShowFilter((prevShowFilter) => !prevShowFilter);
  }, []);

  const stockTransferReqData = billSummary?.stock_transfer;
  const stock_inData = billSummary?.stock_in;
  const stock_outData = billSummary?.stock_out;
  const recentActivity = billSummary?.recent_activity;

  // const TransactionSummary = [
  //   {
  //     conClass:
  //       "bg-[var(--trans-stats-con-green-bg)] rounded-[12px] h-auto w-[25%] p-3 flex justify-between",
  //     label: "Stock Transfer Requests",
  //     value: (
  //       <span>
  //         Total : ₹{stockTransferReqData?.total || 0} |{" "}
  //         {stockTransferReqData?.total_qty || 0} Units
  //       </span>
  //     ),
  //     desc: (
  //       <div className="flex flex-col gap-2">
  //         <span>
  //           Success : {stockTransferReqData?.success?.count || 0} | ₹
  //           {stockTransferReqData?.success?.value || 0} |{" "}
  //           {stockTransferReqData?.success?.qty || 0} Units
  //         </span>
  //         <span className="text-[var(--pending-color)]">
  //           Pending : {stockTransferReqData?.pending?.count || 0} | ₹{" "}
  //           {stockTransferReqData?.pending?.value || 0} |{" "}
  //           {stockTransferReqData?.pending?.qty || 0} Units
  //         </span>
  //       </div>
  //     ),
  //     descClass:
  //       "text-[length:var(--trans-stats-con-value1-fs)] font-[var(--trans-stats-con-value1-fw)] text-[var(--trans-stats-con-green-fg)]",
  //     icon: (
  //       <ArrowRightLeft size={16} color="var(--trans-stats-con-green-fg)" />
  //     ),
  //     labelClass:
  //       "text-[length:var(--trans-stats-con-label1-fs)] font-[var(--trans-stats-con-label1-fw)] text-[var(--trans-stats-con-label1-fg)]",
  //     valueClass:
  //       "text-[length:var(--trans-stats-con-value1-fs)] font-[var(--trans-stats-con-value1-fw)] text-[var(--trans-stats-con-value1-fg)] mt-3",
  //   },
  //   {
  //     conClass:
  //       "bg-[var(--trans-stats-con-orange-bg)] rounded-[12px] h-auto w-[25%] p-3 flex justify-between",
  //     label: "Stock In",
  //     value: (
  //       <div className="flex flex-col gap-2">
  //         <span>Value : ₹{stock_inData?.value || 0}</span>
  //         <span>Quantity : {stock_inData?.qty || 0} Units</span>
  //         <span
  //           className={`flex items-center gap-1 ${
  //             stock_inData?.value_pct_vs_yday >= 0
  //               ? "text-[var(--trans-stats-con-green-fg)]"
  //               : "text-[var(--trans-stats-con-red-fg)]"
  //           }`}
  //         >
  //           {stock_inData?.value_pct_vs_yday >= 0 ? (
  //             <ArrowUp size={16} />
  //           ) : (
  //             <ArrowDown size={16} />
  //           )}
  //           {stock_inData?.value_pct_vs_yday || 0}%
  //         </span>
  //       </div>
  //     ),
  //     icon: <ArrowDown size={16} color="var(--trans-stats-con-orange-fg)" />,
  //     labelClass:
  //       "text-[length:var(--trans-stats-con-label1-fs)] font-[var(--trans-stats-con-label1-fw)] text-[var(--trans-stats-con-label1-fg)]",
  //     valueClass:
  //       "text-[length:var(--trans-stats-con-value1-fs)] font-[var(--trans-stats-con-value1-fw)] text-[var(--trans-stats-con-value1-fg)] mt-3",
  //   },
  //   {
  //     conClass:
  //       "bg-[var(--trans-stats-con-red-bg)] rounded-[12px] h-[7rem] w-[25%] p-3 flex justify-between",
  //     label: "Stock Out",
  //     value: (
  //       <div className="flex flex-col gap-2">
  //         <span>Value : ₹{stock_outData?.value || 0}</span>
  //         <span>Quantity : {stock_outData?.qty || 0} Units</span>
  //         <span
  //           className={`flex items-center gap-1 ${
  //             stock_outData?.value_pct_vs_yday >= 0
  //               ? "text-[var(--trans-stats-con-green-fg)]"
  //               : "text-[var(--trans-stats-con-red-fg)]"
  //           }`}
  //         >
  //           {stock_outData?.value_pct_vs_yday >= 0 ? (
  //             <ArrowUp size={16} />
  //           ) : (
  //             <ArrowDown size={16} />
  //           )}
  //           {stock_outData?.value_pct_vs_yday || 0}%
  //         </span>
  //       </div>
  //     ),
  //     icon: <ArrowUp size={16} color="var(--trans-stats-con-red-fg)" />,
  //     labelClass:
  //       "text-[length:var(--trans-stats-con-label1-fs)] font-[var(--trans-stats-con-label1-fw)] text-[var(--trans-stats-con-label1-fg)]",
  //     valueClass:
  //       "text-[length:var(--trans-stats-con-value1-fs)] font-[var(--trans-stats-con-value1-fw)] text-[var(--trans-stats-con-value1-fg)] mt-3",
  //   },
  //   {
  //     conClass:
  //       "bg-[var(--trans-stats-con-blue-bg)] rounded-[12px] h-auto w-[25%] p-3 flex justify-between",
  //     label: "Recent Activity ",
  //     value: (
  //       <div className="flex flex-col gap-2">
  //         <span>Value : ₹{recentActivity?.value || 0}</span>
  //         <span>Quantity : {recentActivity?.qty || 0} Units</span>
  //         <span>Last 24 Hours</span>
  //       </div>
  //     ),
  //     icon: <TimerIcon size={16} color="var(--trans-stats-con-blue-fg)" />,
  //     labelClass:
  //       "text-[length:var(--trans-stats-con-label1-fs)] font-[var(--trans-stats-con-label1-fw)] text-[var(--trans-stats-con-label1-fg)]",
  //     valueClass:
  //       "text-[length:var(--trans-stats-con-value1-fs)] font-[var(--trans-stats-con-value1-fw)] text-[var(--trans-stats-con-value1-fg)] mt-3",
  //   },
  // ];

  // const summaryArray =
  //   TransactionSummary?.length > 0 ? (
  //     <div className="px-[24px] pt-[16px] flex gap-5">
  //       {TransactionSummary?.map((sum) => (
  //         <TransSummaryComp sum={sum} />
  
  //       ))}
  //     </div>
  //   ) : (
  //     <></>
  //   );
  // Responsive cards config (no fixed widths/heights)
const TransactionSummary = [
  {
    conClass:
      "bg-[var(--trans-stats-con-green-bg)] rounded-[12px] p-3 sm:p-4 flex flex-col md:flex-row justify-between gap-3 md:gap-4",
    label: "Stock Transfer Requests",
    value: (
      <span>
        Total : ₹{stockTransferReqData?.total || 0} |{" "}
        {stockTransferReqData?.total_qty || 0} Units
      </span>
    ),
    desc: (
      <div className="flex flex-col gap-2">
        <span>
          Success : {stockTransferReqData?.success?.count || 0} | ₹
          {stockTransferReqData?.success?.value || 0} |{" "}
          {stockTransferReqData?.success?.qty || 0} Units
        </span>
        <span className="text-[var(--pending-color)]">
          Pending : {stockTransferReqData?.pending?.count || 0} | ₹{" "}
          {stockTransferReqData?.pending?.value || 0} |{" "}
          {stockTransferReqData?.pending?.qty || 0} Units
        </span>
      </div>
    ),
    descClass:
      "text-[length:var(--trans-stats-con-value1-fs)] font-[var(--trans-stats-con-value1-fw)] text-[var(--trans-stats-con-green-fg)]",
    icon: <ArrowRightLeft size={16} color="var(--trans-stats-con-green-fg)" />,
    labelClass:
      "text-[length:var(--trans-stats-con-label1-fs)] font-[var(--trans-stats-con-label1-fw)] text-[var(--trans-stats-con-label1-fg)]",
    valueClass:
      "text-[length:var(--trans-stats-con-value1-fs)] font-[var(--trans-stats-con-value1-fw)] text-[var(--trans-stats-con-value1-fg)] mt-2",
  },
  {
    conClass:
      "bg-[var(--trans-stats-con-orange-bg)] rounded-[12px] p-3 sm:p-4 flex flex-col md:flex-row justify-between gap-3 md:gap-4",
    label: "Stock In",
    value: (
      <div className="flex flex-col gap-2">
        <span>Value : ₹{stock_inData?.value || 0}</span>
        <span>Quantity : {stock_inData?.qty || 0} Units</span>
        <span
          className={`flex items-center gap-1 ${
            stock_inData?.value_pct_vs_yday >= 0
              ? "text-[var(--trans-stats-con-green-fg)]"
              : "text-[var(--trans-stats-con-red-fg)]"
          }`}
        >
          {stock_inData?.value_pct_vs_yday >= 0 ? (
            <ArrowUp size={16} />
          ) : (
            <ArrowDown size={16} />
          )}
          {stock_inData?.value_pct_vs_yday || 0}%
        </span>
      </div>
    ),
    icon: <ArrowDown size={16} color="var(--trans-stats-con-orange-fg)" />,
    labelClass:
      "text-[length:var(--trans-stats-con-label1-fs)] font-[var(--trans-stats-con-label1-fw)] text-[var(--trans-stats-con-label1-fg)]",
    valueClass:
      "text-[length:var(--trans-stats-con-value1-fs)] font-[var(--trans-stats-con-value1-fw)] text-[var(--trans-stats-con-value1-fg)] mt-2",
  },
  {
    conClass:
      "bg-[var(--trans-stats-con-red-bg)] rounded-[12px] p-3 sm:p-4 flex flex-col md:flex-row justify-between gap-3 md:gap-4",
    label: "Stock Out",
    value: (
      <div className="flex flex-col gap-2">
        <span>Value : ₹{stock_outData?.value || 0}</span>
        <span>Quantity : {stock_outData?.qty || 0} Units</span>
        <span
          className={`flex items-center gap-1 ${
            stock_outData?.value_pct_vs_yday >= 0
              ? "text-[var(--trans-stats-con-green-fg)]"
              : "text-[var(--trans-stats-con-red-fg)]"
          }`}
        >
          {stock_outData?.value_pct_vs_yday >= 0 ? (
            <ArrowUp size={16} />
          ) : (
            <ArrowDown size={16} />
          )}
          {stock_outData?.value_pct_vs_yday || 0}%
        </span>
      </div>
    ),
    icon: <ArrowUp size={16} color="var(--trans-stats-con-red-fg)" />,
    labelClass:
      "text-[length:var(--trans-stats-con-label1-fs)] font-[var(--trans-stats-con-label1-fw)] text-[var(--trans-stats-con-label1-fg)]",
    valueClass:
      "text-[length:var(--trans-stats-con-value1-fs)] font-[var(--trans-stats-con-value1-fw)] text-[var(--trans-stats-con-value1-fg)] mt-2",
  },
  {
    conClass:
      "bg-[var(--trans-stats-con-blue-bg)] rounded-[12px] p-3 sm:p-4 flex flex-col md:flex-row justify-between gap-3 md:gap-4",
    label: "Recent Activity",
    value: (
      <div className="flex flex-col gap-2">
        <span>Value : ₹{recentActivity?.value || 0}</span>
        <span>Quantity : {recentActivity?.qty || 0} Units</span>
        <span>Last 24 Hours</span>
      </div>
    ),
    icon: <TimerIcon size={16} color="var(--trans-stats-con-blue-fg)" />,
    labelClass:
      "text-[length:var(--trans-stats-con-label1-fs)] font-[var(--trans-stats-con-label1-fw)] text-[var(--trans-stats-con-label1-fg)]",
    valueClass:
      "text-[length:var(--trans-stats-con-value1-fs)] font-[var(--trans-stats-con-value1-fw)] text-[var(--trans-stats-con-value1-fg)] mt-2",
  },
];

// Responsive grid container (1 / 2 / 4 columns)
const summaryArray =
  TransactionSummary?.length > 0 ? (
    <div className="px-4 sm:px-6 pt-4 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 sm:gap-5">
      {TransactionSummary.map((sum, idx) => (
        <TransSummaryComp key={idx} sum={sum} />
      ))}
    </div>
  ) : null;

  return (
    <InnerLayout
      permissionFn={permissionFn}
      module="invoice"
      list={true}
      title="Stock Management"
    >
      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <></>
      ) : (
        <>
          <DynamicTransactionTable
            summaryArray={summaryArray}
            extraFilters={[{ label: "Item Code", value: "item_code" }]}
            cloneFn={(id) => {
              navigate(`/add-stock-transfer?transferId=${id}`);
            }}
            ViewAction={stockTransferViewAction}
            hideEditOnDataSync={true}
            transaction="Stock Transfer"
            transaction_type="stock_transfer"
            setInvoiceItems={setInvoiceItems}
            invoiceItems={[]}
            options={options}
            orders={orders}
            setOrders={setOrders}
            tableHeading1={tableHeading1}
            is_checkbox_req={true}
            onClickItemFn={(id) => navigate(`/view-stock-transfer/${id}`)}
            list={true}
            onclkFn={() => {
              navigate("/add-stock-transfer");
            }}
            permissionFn={permissionFn}
            module={"stock_transfer"}
            path="stock-transfer"
            reload={reload}
            setReload={setReload}
            loading={loading}
            setLoading={setLoading}
            deleteAction={voidStockTransferAction}
            label="Stock Transfer"
            showFilter={showFilter}
            filterFn={handleFilterClick}
            setFilterData={setFilterData}
            filterData={filterData}
            paginationProps={paginationProps}
            tableHeading={heading}
            tableBodyData={tableBodyData}
            placeholder="Search (/)"
            filterBy={filterby}
            initialFilter={{
              sort_by: "",
              sort_order: "",
              selectColumn: "stock_transfer_doc_number",
              from: "",
              to: "",
              inputValue: "",
              filterValue: "",
            }}
            transactionKey="itt"
            actionsPermissions={{
              edit: ["draft"], // Edit allowed for "open" and "draft"
              delete: ["draft", "success"], // Delete allowed only for "open"
              print: ["draft", "success", "yes"], // Print allowed for "open" and "closed"
              // send: ["open", "closed", "draft", "yes"], // Share allowed for "open" and "closed"
              clone: ["success", "draft", "yes"], // Share allowed for "open" and "closed"
            }}
          />
         
        </>
      )}
    </InnerLayout>
  );
};

export default StockTransferTable;
const tableHeading = [
  {
    label: "STOCK TRANSFER NUMBER",
    value: "stock_transfer_doc_number",
    display: false,
    column: true,
  },
  {
    label: "DATE",
    value: "posting_date",
    display: true,
    column: false,
  },
  {
    label: "ACTION TYPE ",
    value: "stock_management_action",
    display: false,
    column: false,
  },
  {
    label: "SOURCE (FROM)",
    value: "from_warehouse_name",
    display: false,
    column: true,
  },
  {
    label: "DESTINATION (TO)",
    value: "to_warehouse_name",
    display: false,
    column: true,
  },
  {
    label: "TRANSFER STATUS",
    value: "stock_transfer_status",
    display: false,
    column: false,
  },
  {
    label: "IS BILLED",
    value: "is_stock_in_void_able",
    display: false,
    column: false,
  },
  {
    label: "",
    value: "",
    display: false,
    column: false,
  },
];
const tableHeading1 = [
  { label: "PRODUCT NAME", value: "item_name" },
  { label: "ITEM CODE", value: "item_code" },
  { label: "QTY", value: "item_quantity" },
  // { label: "Batch Details", value: "bch" },
  // { label: "Status", value: "item_void_status" },
];

const options = [
  { value: "goods_receipt_note", label: "Goods Receipt Note" },
  { value: "purchase_invoice", label: "Purchase Invoice" },
];
